<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div [formGroup]="dataForm" class="orbit-filter-fields flex-layout-column flex-layout-gap-15px">
	<div class="filter-row order-filter-fields flex-layout-row flex-layout-align-start-center flex-layout-gap-10px">
		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Order Number</mat-label>
				<input formControlName="orderNumber" matInput />
			</mat-form-field>
		</div>

		<div *ngIf="!isOrganiserOrderList" class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Organiser</mat-label>
				<input formControlName="organiser" matInput />
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Event</mat-label>
				<input formControlName="event" matInput />
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Ticket Type</mat-label>
				<mat-select formControlName="ticketType" name="ticketType" multiple>
					<mat-select-trigger>
						{{ getGroupedMultiSelectDisplayValue(ticketType, ticketTypeLookupData, 'All Types') }}
					</mat-select-trigger>
					<mat-option #allTicketTypesSelected
						(click)="toggleAllGrouped(); $event.stopPropagation(); $event.preventDefault()"
						[value]="0"> All Types </mat-option>

					<mat-option [value]="-1"
						(click)="toggleGroupedSubset(entryTicketTypeLookupData, -1); $event.stopPropagation(); $event.preventDefault()">
						All Entry
					</mat-option>

					<mat-option [value]="-2"
						(click)="toggleGroupedSubset(nonEntryTicketTypeLookupData, -2); $event.stopPropagation(); $event.preventDefault()">
						All Non Entry
					</mat-option>

					<mat-option [value]="-3"
						(click)="toggleGroupedSubset(glampingTicketTypeLookupData, -3); $event.stopPropagation(); $event.preventDefault()">
						All Glamping
					</mat-option>

					<ng-container *ngFor="let group of ticketTypeLookupData">
						<mat-optgroup [label]="group.name">
							<mat-option #matOption *ngFor="let item of group.items" [value]="item.id"
								(click)="groupedMultiSelectSelectionChanged(matOption.selected, ticketType, ticketTypeLookupData)">
								{{ item.name }}
							</mat-option>
						</mat-optgroup>
					</ng-container>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Venue</mat-label>
				<input formControlName="venue" matInput />
			</mat-form-field>
		</div>

		<div *ngIf="!customerId" class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Customer</mat-label>
				<input formControlName="customer" matInput />
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Event Date (from)</mat-label>
				<input formControlName="eventDateFrom" matInput [matDatepicker]="dpEventDateFrom" />
			<mat-datepicker-toggle aria-label="Select date" matTooltip="Select date" matSuffix [for]="dpEventDateFrom"><svg lucideCalendarDays class="orbit-picker-icon orbit-icon" matDatepickerToggleIcon aria-hidden="true"></svg></mat-datepicker-toggle>
				<mat-datepicker #dpEventDateFrom></mat-datepicker>
			</mat-form-field>
		</div>
		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Event Date (to)</mat-label>
				<input formControlName="eventDateTo" matInput [matDatepicker]="dpEventDateTo" />
			<mat-datepicker-toggle aria-label="Select date" matTooltip="Select date" matSuffix [for]="dpEventDateTo"><svg lucideCalendarDays class="orbit-picker-icon orbit-icon" matDatepickerToggleIcon aria-hidden="true"></svg></mat-datepicker-toggle>
				<mat-datepicker #dpEventDateTo></mat-datepicker>
			</mat-form-field>
		</div>
		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Order Date (from)</mat-label>
				<input formControlName="orderDateFrom" matInput [matDatepicker]="dpOrderDateFrom" />
			<mat-datepicker-toggle aria-label="Select date" matTooltip="Select date" matSuffix [for]="dpOrderDateFrom"><svg lucideCalendarDays class="orbit-picker-icon orbit-icon" matDatepickerToggleIcon aria-hidden="true"></svg></mat-datepicker-toggle>
				<mat-datepicker #dpOrderDateFrom></mat-datepicker>
			</mat-form-field>
		</div>
		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Order Date (to)</mat-label>
				<input formControlName="orderDateTo" matInput [matDatepicker]="dpOrderDateTo" />
			<mat-datepicker-toggle aria-label="Select date" matTooltip="Select date" matSuffix [for]="dpOrderDateTo"><svg lucideCalendarDays class="orbit-picker-icon orbit-icon" matDatepickerToggleIcon aria-hidden="true"></svg></mat-datepicker-toggle>
				<mat-datepicker #dpOrderDateTo></mat-datepicker>
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Payment Plan</mat-label>
				<mat-select formControlName="paymentPlan" name="paymentPlan">
					<mat-option [value]="0"> All Options </mat-option>
					<mat-option *ngFor="let lookup of paymentPlanLookupData" [value]="lookup.id">
						{{ lookup.text }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Event Genre</mat-label>
				<mat-select formControlName="eventGenre" name="eventGenre" multiple>
					<mat-select-trigger>
						{{ getMultiSelectDisplayValue(eventGenre, eventGenreLookupData, 'All Genres') }}
					</mat-select-trigger>
					<mat-option #allEventGenresSelected
						(click)="toggleAllMultiSelectSelection(allEventGenresSelected, eventGenre, eventGenreLookupData)"
						[value]="0"> All Genres </mat-option>
					<mat-option #matOption *ngFor="let lookup of eventGenreLookupData" [value]="lookup.id"
						(click)="multiSelectSelectionChanged(matOption.selected, eventGenre, eventGenreLookupData)">
						{{ lookup.text }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>

		<div class="bottom-padding-15px">
			<mat-form-field subscriptSizing="dynamic">
				<mat-label>Event Status</mat-label>
				<mat-select formControlName="eventStatus" name="eventStatus" multiple>
					<mat-select-trigger>
						{{ getMultiSelectDisplayValue(eventStatus, eventStatusLookupData, 'All Statuses') }}
					</mat-select-trigger>
					<mat-option #allEventStatusesSelected
						(click)="toggleAllMultiSelectSelection(allEventStatusesSelected, eventStatus, eventStatusLookupData)"
						[value]="0"> All Statuses </mat-option>
					<mat-option #matOption *ngFor="let lookup of eventStatusLookupData" [value]="lookup.id"
						(click)="multiSelectSelectionChanged(matOption.selected, eventStatus, eventStatusLookupData)">
						{{ lookup.text }}
					</mat-option>
				</mat-select>
			</mat-form-field>
		</div>
	</div>
</div>
